// Vendors
import React from 'react';
// Components
import { LayoutComponent } from 'components/layout/layout.component';
import { ContractWrapper } from './components/contract-wrapper/contract-wrapper.component';
import { ContractOrchestratorComponent } from './components/orchestrator/contract-orchestrator.component';
// Constants
import {
  CONTRACT_LAYOUT_ASSET_COMPONENT_PROPS,
  CONTRACT_LAYOUT_COMPONENT_PROPS,
} from './constants/contract.constants';
// Contexts
import { FetchErrorContextConsumerHOC } from 'contexts/fetch-error.context';
import { ContractContextConsumerHOC } from './contexts/contract.context';
// Hooks
import { useContractContainerHook } from './hooks/contract.hook';
// Translations
import { CONTRACT_TITLES } from './translations/contract.translations';

const ContractBaseContainer = (): React.JSX.Element => {
  const { error, externalFetching, contractState } = useContractContainerHook();

  return (
    <ContractWrapper contractState={contractState}>
      <LayoutComponent
        {...{ ...CONTRACT_LAYOUT_COMPONENT_PROPS, error, externalFetching }}
        title={CONTRACT_TITLES[contractState]}
        assetId={CONTRACT_LAYOUT_ASSET_COMPONENT_PROPS[contractState]}
      >
        <ContractOrchestratorComponent />
      </LayoutComponent>
    </ContractWrapper>
  );
};

const ContractContainer = ContractContextConsumerHOC(
  FetchErrorContextConsumerHOC(ContractBaseContainer)
);

export { ContractContainer };
